/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/no-unused-state */
import React from 'react'
import { ActionApiParams, IERPChannel, ISelectedStoreMap, IXScreenProps } from 'x/types'
import * as util from 'x/utils/util'
import * as subscriptionUtil from 'x/utils/subscriptionUtil'
import * as NavActions from 'x/utils/navigation'
import _ from 'lodash'
import * as acl from 'x/utils/acl'
import CONS from 'x/config/constants'
import p from 'x/config/platform-specific'

interface IBaseERPListViewProps extends IXScreenProps {
  selectedStore: ISelectedStoreMap
  getErpChannels: (params: ActionApiParams) => void
}

interface IBaseERPListViewState {
  erpChannelList: IERPChannel[]
  isInitialized?: boolean
}

export default abstract class BaseERPListView extends React.Component<IBaseERPListViewProps, IBaseERPListViewState> {
  // abstract async handleSubmitForm(response: any): Promise<void>
  // abstract didMountCheckPermissionForPhone?: () => void
  // validationSchema: Yup.ObjectSchema<any>
  // imgManagerIDRef: React.RefObject<any>
  // webview: React.RefObject<any>
  isViewMounted: boolean

  constructor(props) {
    super(props)
    this.state = {
      erpChannelList: null,
      isInitialized: false,
    }
    // this.webview = React.createRef()
    // this.imgManagerIDRef = React.createRef()

    this.isViewMounted = false
  }

  async componentDidMount() {
    this.isViewMounted = true
    await util.delay(100)
    await this._getErpChannelList()
    await util.delay(100)
    await util.setStatePromise(this, { isInitialized: true })
  }

  componentWillUnmount(): void {
    this.isViewMounted = false
  }

  _getErpChannelList = async () => {
    if (!this.isViewMounted) {
      return
    }
    const { selectedStore, getErpChannels } = this.props
    const store_id = selectedStore.get('id')
    const body = {
      store_id,
    }
    const isHelperUser = util.isHelper()
    const havePermListErp = acl.canDoAtSelectedStore(CONS.PERM_STORE_HELPER.ERP_CHANNEL_LIST)
    // console.log('havePermListErp => ', havePermListErp)
    if (isHelperUser && !havePermListErp) {
      return
    }
    const res: { erp_channels: IERPChannel[] } = await new Promise((resolveSave) => {
      getErpChannels({
        body,
        // @ts-ignore successCallback แดง
        successCallback: resolveSave,
        failedCallback: () => resolveSave(null),
      })
    })
    // console.log('storesApiOptions => ', res)
    if (res.erp_channels) {
      this.setState({
        erpChannelList: res.erp_channels,
      })
    }
    // const res = await api.postV2('erp/channel/lists', reqBody, apiOptions)
    // console.log('res => ', res)

    // p.op.showToast('ผูกรหัสบัญชีเรียบร้อยแล้ว', 'success')
    // const params = util.getNavParams(this.props)
    // const { callBack } = params
  }

  goBack = () => {
    util.navGoBack(this.props)
  }

  _navToErpCreateView = () => {
    const { navigation, selectedStore } = this.props
    if (!acl.canDoAtSelectedStore(CONS.PERM_STORE_HELPER.ERP_CHANNEL_ADD)) {
      p.op.showConfirmationOkOnly('', 'คุณไม่ได้รับสิทธิ์การใช้งานส่วนนี้')
      return
    }
    const maxQuota = util.checkMaxQuotaCreateMkpChannelAndErp()
    if (maxQuota) {
      subscriptionUtil.navToSubscriptionChoiceView(this.props.navigation, 'mkp_quota')
      // p.op.showConfirmationOkOnly(p.op.t('Subscription.warning.insufficientTypeTitle'), p.op.t('Subscription.warning.insufficientTypeMsg'))
      return
    }

    navigation.dispatch(
      NavActions.navToERPCreateView({
        store_id: selectedStore.get('id'),
        callBack: (newErpChannel: IERPChannel) => this._callBackFromCreateErpChannel(newErpChannel),
      })
    )
  }

  _callBackFromCreateErpChannel = (newErpChannel: IERPChannel) => {
    // console.log('_callBackFromCreateErpChannel Main => ', newErpChannel)
    const { erpChannelList } = this.state
    const newErpChannelList: IERPChannel[] = [newErpChannel]
    if (!_.isNil(erpChannelList) && erpChannelList.length > 0) {
      erpChannelList.forEach((erpChannel) => {
        newErpChannelList.push(erpChannel)
      })
    }
    this.setState({ erpChannelList: newErpChannelList })
  }

  callBaclFromUpdateErpChannel = (newErpChannel: IERPChannel) => {
    const { erpChannelList } = this.state
    const newErpChannelList: IERPChannel[] = []
    if (!_.isNil(erpChannelList) && erpChannelList.length > 0) {
      erpChannelList.forEach((erpChannel) => {
        if (erpChannel.id === newErpChannel.id) {
          newErpChannelList.push(newErpChannel)
        } else {
          newErpChannelList.push(erpChannel)
        }
      })
    }
    this.setState({ erpChannelList: newErpChannelList })
  }

  _navToErpDetailView = (erp_ch_id: number) => {
    const { navigation, selectedStore } = this.props
    navigation.dispatch(
      NavActions.navToERPDetailView({
        store_id: selectedStore.get('id'),
        erp_ch_id,
        callBackUpdateNewErp: (newErpChannel: IERPChannel) => this.callBaclFromUpdateErpChannel(newErpChannel),
        callBackUpdateNewErpList: (newErpChannels: IERPChannel[]) => this.setState({ erpChannelList: newErpChannels }),
      })
    )
  }
}
